import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import logo from '../../../../assets/Logo.svg';
import darkLogo from '../../../../assets/DarkLogo.svg';
import iconMenu from '../../../../assets/iconMenu.svg';
import darkIconMenu from '../../../../assets/darkMenu.png';
import { logoStyles } from '../../../../styles/commonStyles';
import { mobileHeaderStyles } from './MobileHeader.styles';
import MobileSidebar from './MobileSidebar/MobileSidebar';

const MobileHeader = ({ isSecondary = false }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const styles = mobileHeaderStyles();

  const handleMenuClick = () => {
    setIsSidebarOpen(true);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      <Box sx={styles.container}>
        <Box>
          <img
            src={isSecondary ? logo : darkLogo}
            alt="Royal Vista Logo"
            fetchPriority="high"
            style={logoStyles}
          />
        </Box>
        <IconButton
          onClick={handleMenuClick}
          sx={styles.menuButton}
        >
          <Box
            component="img"
            src={isSecondary ? iconMenu : darkIconMenu}
            alt="Menu"
            sx={styles.menuIcon}
          />
        </IconButton>
      </Box>
      <MobileSidebar
        isOpen={isSidebarOpen}
        onClose={handleCloseSidebar}
      />
    </>
  );
};

export default MobileHeader;

